import { cleanUpChanges } from '@components/bid_request/details/utils';
import type { ID, LotChanges } from 'types';

/**
 * `cleanUpChanges` over one lot's overlay entry, so every other entry keeps its object and the lots
 * built from them can be told unchanged by reference.
 */
export const cleanUpLotChanges = (changes: Record<ID, LotChanges>, lotId: ID): Record<ID, LotChanges> => {
  const { [lotId]: lotChanges, ...rest } = changes;
  if (!lotChanges) return changes;

  const cleaned = cleanUpChanges({ [lotId]: lotChanges })[lotId];

  return cleaned ? { ...rest, [lotId]: cleaned } : rest;
};
